import {Howl} from 'howler/dist/howler';

let players = null;
let player = null;
const howlerList = {};

function formatTime(secs) {
	let minutes = Math.floor(secs / 60) || 0;
	let seconds = secs - minutes * 60 || 0;

	return `${minutes}:${(seconds < 10 ? '0' : '') + seconds}`;
}

function convertTime(hour, minute, secs) {
	let hours = hour * 60 * 60;
	let minutes = minute * 60;
	let seconds = secs;

	return hours + minutes + seconds;
}

class Player {
	constructor(container) {
		this.player = container;
		this.playButton = container.find('.play');
		this.pauseButton = container.find('.pause');
		this.loader = container.find('.loader');
		this.rate = container.find('.rate');
		this.partItem = container.closest('.js-player-parent').find('.part-item');
		this.playerTime = container.find('.time');
		this.progress = container.find('.progress');
		this.timer = container.find('.timer');
		this.duration = container.find('.duration');
		this.eq = container.find('.eq');

		this.raf = null;
		this.srcFiles = container.find('audio source');

		this.init();
	}

	init() {
		const self = this;
		let interval = null;

		let files = this.srcFiles.map((srcFileIndex, srcFile) => $(srcFile).attr('src'));

		this.howler = new Howl({
			src: files.get(),
			// volume: 0.3,
			preload: 'metadata',
			html5: true,
			onplay() {
				self.playButton.addClass('is-hidden');
				self.loader.addClass('is-hidden');
				self.pauseButton.removeClass('is-hidden');
				self.progres();
				self.eq.addClass('is-active');

				// const title = self.player.find('.player__title').text();
				// ga('send', 'event', 'audio', 'play', title, {nonInteraction: false});

				interval = setInterval(() => {
					// ga('send', 'event', 'audio', 'timing 30s', title, 30);
				}, 30000);
			},
			onpause() {
				self.playButton.removeClass('is-hidden');
				self.eq.removeClass('is-active');
				self.pauseButton.addClass('is-hidden');

				if (interval) {
					clearInterval(interval);
				}
			},
			onstop() {
				self.playButton.removeClass('is-hidden');
				self.eq.removeClass('is-active');
				self.pauseButton.addClass('is-hidden');

				if (interval) {
					clearInterval(interval);
				}
			},
			onload() {
				let duration = self.howler.duration();

				// Display the duration.
				self.duration.html(
					formatTime(Math.round(duration)),
				);
				// rate.max = duration;
			},
			onend() {
				self.playButton.removeClass('is-hidden');
				self.eq.removeClass('is-active');
				self.pauseButton.addClass('is-hidden');
				self.howler.seek(0);

				// const title = self.player.find('.player__title').text();
				// ga('send', 'event', 'audio', 'finish', title);

				if (interval) {
					clearInterval(interval);
				}
			},
		});

		this.partItem.on('click.player', (event) => {
			let timePartHour = Number($(event.currentTarget).data('seek-h')) || 0;
			let timePartMinute = Number($(event.currentTarget).data('seek-m')) || 0;
			let timePartSec = Number($(event.currentTarget).data('seek-s')) || 0;
			let timePart = convertTime(timePartHour, timePartMinute, timePartSec);

			Object.keys(howlerList).forEach((key) => howlerList[key].stop());

			this.playPartPlayer(timePart);
		});

		this.playerTime.on('click.player', (event) => {
			let time = Number($(event.currentTarget).data('time'));

			const currentPlayerTime = this.playerTime.filter(`[data-time="${time}"]`);

			if ($(event.currentTarget).hasClass('is-active')) {
				time = 1;
			}

			this.playerTime.removeClass('is-active');
			this.howler.rate(time);

			if (time <= 1) {
				currentPlayerTime.removeClass('is-active');
			} else {
				// const title = self.player.find('.player__title').text();
				// ga('send', 'event', 'audio', `speed up x${time}`, title);

				currentPlayerTime.addClass('is-active');
			}
		});

		this.navigation();
		this.progres();
		this.timeline();
	}

	destroy() {
		cancelAnimationFrame(this.raf);

		this.raf = null;

		this.howler.stop();
		this.howler.seek(0);
		this.howler.unload();
		this.howler = null;

		this.playerTime.off('.player');
		this.partItem.off('.player');
		this.rate.off('.player');
		this.playButton.off('.player');
		this.pauseButton.off('.player');
	}

	timeline() {
		this.rate.on('input.player', (event) => {
			this.howler.seek(this.howler.duration() * Number($(event.currentTarget).val()) / 100);
			this.progres('timelineClick');
		});
	}

	navigation() {
		this.playButton.on('click.player', () => {
			this.playButton.addClass('is-hidden');
			this.loader.removeClass('is-hidden');

			if (this.playButton.hasClass('is-pause')) {
				this.playButton.removeClass('is-pause');

				Object.keys(howlerList).forEach((key) => howlerList[key].pause());
			} else {
				Object.keys(howlerList).forEach((key) => howlerList[key].stop());
			}

			this.howler.play();
		});

		this.pauseButton.on('click.player', () => {
			this.playButton.addClass('is-hidden');
			this.playButton.addClass('is-pause');

			this.howler.pause();
		});
	}

	progres(timelineClick) {
		const seek = this.howler.seek() || 0;

		this.progress.css('width', `${seek / this.howler.duration() * 100 || 0}%`);

		if (this.howler.playing() || timelineClick) {
			this.raf = requestAnimationFrame(this.progres.bind(this));
			this.timer.html(formatTime(Math.round(seek)));
		}
	}

	playPartPlayer(time) {
		this.howler.stop();
		this.howler.seek(time);
		this.howler.play();
	}
}

function init(container) {
	players = container.find('.player:not([data-interface])');

	players.each((playerCurrentIndex, playerCurrent) => {
		const playerId = $(playerCurrent).data('person');

		player = new Player(container.find(`.player[data-person="${playerId}"]`));

		howlerList[[playerCurrentIndex]] = player.howler;
	});
}

function destroy() {
	player.destroy();

	player = null;
}

export default {
	init,
	destroy,
};

